import { useCallback } from 'react';

import { useNotification } from '@lumapps/notifications/hooks/useNotifications';
import { GLOBAL } from '@lumapps/translations';
import { copyText } from '@lumapps/utils/browser/copyText';

/**
 * Returns a callback that copies a given string to the clipboard and shows a success notification to the user.
 */
export const useCopyToClipboard = () => {
    const { success } = useNotification();

    return useCallback(
        (string: string) => {
            copyText(string);
            success({ translate: GLOBAL.COPIED });
        },
        [success],
    );
};
